import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function WeatherForecastDay(props) {
  function day() {
    let date = new Date(props.data.time * 1000);
    let day = date.getDay();
    let days = ["sun", "Mon", "Tue", "Wed", "Thu", "Fri", "sut"];

    return days[day];
  }
  return (
    <div className="WeatherForecastDay">
      <div className="weatherForecast-day">{day()}</div>

      <div className="weatherForecast-icon">
        <WeatherIcon data={{ icon: props.data.condition.icon_url }} />
      </div>

      <div className="WeatherForecast-temperatures">
        <span className="WeatherForecast-temperatures-max">
          {Math.round(props.data.temperature.maximum)}º
        </span>

        <span className="WeatherForecast-temperatures-min">
          {Math.round(props.data.temperature.minimum)}º
        </span>
      </div>
    </div>
  );
}
